import rpcHeaders from '#/store/headers';
import { queryProjectClient, commentClient } from '#/clients';

export function emptyState() {
  return {

  };
}

export const getters = {

};

export const mutations = {

};

export const actions = {
  loadList: async ({ rootState }, request) => {
    console.log('loading comment list', request.toObject());
    try {
      const headers = await rpcHeaders(rootState);
      return new Promise((resolve, reject) => {
        queryProjectClient.listComments(request, headers, (err, response) => {
          if (err != null) {
            console.log('received err from listComments', err);
            return reject(err);
          }
          return resolve(response);
        });
      });
    } catch (error) {
      console.log('caught error loading job page:', error);
      return Promise.reject(error);
    }
  },
  addComment: async ({ rootState }, request) => {
    console.log('saving comment', request.toObject());
    try {
      const headers = await rpcHeaders(rootState);
      return new Promise((resolve, reject) => {
        commentClient.addComment(request, headers, (err, response) => {
          if (err != null) {
            console.log('received err from addComment ', err);
            return reject(err);
          }
          return resolve(response);
        });
      });
    } catch (error) {
      console.log('caught error in addComment', error);
      return Promise.reject(error);
    }
  },
};

export default {
  namespaced: true,
  state: emptyState(),
  getters,
  mutations,
  actions,
};
